import { Card } from "../../components/Card";

import { useState } from "react";
import { Button } from "../../components/Button";
import { UsersList } from "./UsersList";
import { Tabs } from "./components/Tabs";
import { RegionList } from "../region/RegionList";
import { TerritoryList } from "../territory/TerritoryList";
import { NotificationButton } from "../../components/NotificationButton";
import { Licenses } from "./licenses/Licenses";
import { ZoneList } from "../zone/ZoneList";

export function ManageUsers() {
  const [tab, setTab] = useState("users");
  return (
    <div>
      <div className="bg-background p-4 pt-20 lg:p-8">
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-1">
            <div className="text-black text-2xl font-semibold">Admin Settings</div>
            <div className="justify-start text-black text-lg font-normal">Adjust workspace-wide settings and preferences here for PraxisPro. You can also manage team members and licenses.</div>
          </div>
          <NotificationButton />
        </div>
        <div className="my-4">
          <Tabs value={tab} onChange={setTab} />
        </div>
        {tab === "users" && (
          <UsersList
            key={tab}
          />
        )}
        {tab === "regions" && (
          <RegionList
            key={tab}
          />
        )}
        {tab === "territories" && (
          <TerritoryList
            key={tab}
          />
        )}
        {tab === "zones" && (
          <ZoneList
            key={tab}
          />
        )}
        {tab === "licenses" && (
          <Licenses
            key={tab}
          />
        )}
      </div>
    </div>
  );
}